import React, {ReactElement} from 'react';
import {Props} from './Props';
import BearingCompass from '../../../../../../components/BearingCompass';
import {Sign} from '../../../../../../interfaces/GeoJsonSources/GeoJsonPropertiesMsi';
import TimeFormatted from '../../../../../../components/TimeFormatted';
import DateFormatted from '../../../../../../components/DateFormatted';

const TABLE_HEADER_WIDTH = '100px';
class DialogMSI extends React.Component<Props> {

    private getSignImageSource(sign: Sign): string {
        let imageSource = 'assets/vms-msi/ndw-msi-';
        imageSource += sign.pictogram;
        if(sign.flashing) {
            imageSource += '-flashing';
        }
        if(sign.redRing) {
            imageSource += '-red-ring';
        }
        imageSource += '-80.svg';
        return imageSource;
    }

    render(): ReactElement {
        const {currentProperties, showRecordIds} = this.props;
        const signs: Sign[] = JSON.parse(currentProperties.signs as unknown as string) as Sign[];

        return (
            <div>
                <table>
                    <tbody>
                        {showRecordIds && (
                            <tr>
                                <th>ID</th>
                                <td>{currentProperties.id}</td>
                            </tr>
                        )}
                        <tr>
                            <th style={{width: TABLE_HEADER_WIDTH}}>Richting</th>
                            <td>
                                <BearingCompass bearing={currentProperties.bearing} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <th style={{width: TABLE_HEADER_WIDTH}}>Weergave</th>
                            {signs.map((sign, index) => (
                                <td key={index}>
                                    <img
                                        src={this.getSignImageSource(sign)}
                                        width={40}
                                        height={40}
                                        alt={`Sign ${sign.index}`}
                                        style={{display: 'block'}}
                                    />
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th>Event tijd</th>
                            {signs.map((sign, index) => (
                                <td key={index}>
                                    <TimeFormatted dateTime={sign.updatedAt} />
                                    <br/>
                                    <DateFormatted dateTime={sign.updatedAt} />
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DialogMSI;
